module.exports = __webpack_public_path__ + "/images/shop/car-selection-notice/car_selection_notice-fallback--blue.png";